import RichContent from './RichContent'

export default RichContent
